import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { AreaProCustomv6 } from "@shared/v2/Icomoon";
import BaseEvent from "./BaseEvent";
import { noNamer } from "../../../Contacts/ModalViews/helpers";

const AreaProEvent = ({ event, additionalTitle }) => {
  const interactedAtAbsolute = event.interacted_at_absolute;
  const person = useSelector((state) => state.personDetail.person);

  return (<BaseEvent
    icon={<AreaProCustomv6 size="xxl" />}
    title={
      <div className="tw-text-22px">
        <b>{noNamer(person?.data?.attributes?.first_name, person?.data?.attributes?.last_name)}</b> viewed an AreaPro REMO{additionalTitle}
      </div>
    }
    interactedAt={interactedAtAbsolute}
    iconContainerClass="tw-w-40px tw-h-40px"
  >
    {(event.timeline_fields?.report_name || event.timeline_fields?.agent_email) && (
      <div className="tw-flex tw-flex-col tw-gap-[6px] tw-text-22px">
        {event.timeline_fields?.report_name && <span>REMO: {event.timeline_fields?.report_name}</span>}
        {event.timeline_fields?.agent_email && <span>Shared by: {event.timeline_fields?.agent_email}</span>}
      </div>
    )}
  </BaseEvent>)
};

export default AreaProEvent;

AreaProEvent.propTypes = {
  event: PropTypes.shape().isRequired,
  additionalTitle: PropTypes.string,
};

AreaProEvent.defaultProps = {
  additionalTitle: "",
};